export default __webpack_public_path__ + "static/media/close-preview-icon.0da6f92f.svg";